import { useState } from "react";

const BODY_MAX = 4000;

export default function MessageComposer({ onSend, sending, error }) {
  const [text, setText] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    const body = text.trim();
    if (!body || sending) return;
    try {
      await onSend(body);
      setText("");
    } catch {
      // Deliberately keep `text` populated: a failed send must not discard
      // what the user wrote.
    }
  };

  return (
    <form
      data-testid="message-composer"
      onSubmit={submit}
      className="border-t border-slate-200 p-3"
    >
      {error && <p className="mb-2 text-xs text-status-critical">{error}</p>}
      <div className="flex items-end gap-2">
        <textarea
          value={text}
          onChange={(event) => setText(event.target.value.slice(0, BODY_MAX))}
          rows={2}
          placeholder="Write a message"
          aria-label="Message"
          className="flex-1 resize-none rounded-md border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600"
        />
        <button
          type="submit"
          data-testid="message-send"
          disabled={sending || !text.trim()}
          className="px-3 py-2 rounded-md bg-slate-900 text-white text-sm font-medium disabled:opacity-40 transition-colors duration-200"
        >
          {sending ? "Sending" : "Send"}
        </button>
      </div>
    </form>
  );
}
